@use '@flixbus/honeycomb-react/dist/scss/honeycomb-tools';

.container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  .imageLink {
    div[class*='hcr-img-link__content']::after {
      content: none;
    }

    div[class^="hcr-img-box__img-wrapper"] {
      min-height: 0;

      img[class^="hcr-img-box__img"] {
        position: static;
        width: 720px;
        max-width: 100%;
        transform: none;
      }
    }

    div[class^="hcr-img-box__content"] {
      padding-top: var(--hcr-spacing-4);
      text-align: center;
    }
  }

  .buttonContainer {
    display: flex;
    width: 100%;
    justify-content: center;
    padding: var(--hcr-spacing-1) 0;
  }
}
